import script from "./LolerTestingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LolerTestingComponent.vue?vue&type=script&setup=true&lang=js"

import "./LolerTestingComponent.vue?vue&type=style&index=0&id=2fde779d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fde779d"]])

export default __exports__